module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-report-box-button-icon-e4d8b1dc1594801cb07018fb0b490bf6.svg";